import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const PauseIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="PauseIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/pause">
            <g id="vector">
                <path
                    d="M8.91699 4.06738C9.46928 4.06738 9.91699 4.5151 9.91699 5.06738V18.9326C9.91674 19.4847 9.46912 19.9326 8.91699 19.9326H7.88086C7.32873 19.9326 6.88111 19.4847 6.88086 18.9326V5.06738C6.88086 4.5151 7.32857 4.06738 7.88086 4.06738H8.91699Z"
                    fill="currentColor"
                >
                </path>
                <path
                    d="M16.1201 4.06738C16.6724 4.06738 17.1201 4.5151 17.1201 5.06738V18.9326C17.1199 19.4847 16.6722 19.9326 16.1201 19.9326H15.084C14.5319 19.9326 14.0842 19.4847 14.084 18.9326V5.06738C14.084 4.5151 14.5317 4.06738 15.084 4.06738H16.1201Z"
                    fill="currentColor"
                >
                </path>
            </g>
        </g>
    </SvgIcon>
)
